import { NodeModel } from '@projectstorm/react-diagrams';
import { UnBinaryPortModel } from './UnBinaryPortModel';
import _ from 'lodash';
import { ADDPORT, MAINPORT } from "../ConstantNames";
export class UnBinaryNodeModel extends NodeModel {
  constructor(options = {}, color, reduxProps) {
    if (typeof options === 'string') {
      options = {
        name: options,
        color: color,
        reduxProps: reduxProps
      };
    }

    super({
      type: 'unbinary',
      name: 'Untitled',
      color: 'rgb(92,192,125)',
      ...options
    });
    this.addTemplatePorts();
    this.registerEvents();
    this.changeCounter = 0;
    this.unaryPredicates = new Set();
    this.canSelectNode = true;
    this.editable = reduxProps["editable"];
  }

  addPredicate(name) {
    this.addUnaryPredicate(name);
  }

  getReduxProps() {
    return this.getOptions().reduxProps;
  }

  getPredicates() {
    return this.unaryPredicates;
  }

  getMainPort() {
    return this.mainPort;
  }

  isEditable() {
    return this.editable;
  }

  changeEditableState(value) {
    this.editable = value;
  }

  addTemplatePorts() {
    let port = new UnBinaryPortModel(ADDPORT);
    this.appendPort = port;
    port.setMaximumLinks(0);
    this.addPort(port);
    port = new UnBinaryPortModel(MAINPORT); //port.setPortAlignment(PortModelAlignment.TOP);

    this.mainPort = port;
    this.addPort(port);
  }

  registerEvents() {
    let node = this;
    this.registerListener({
      entityRemoved() {
        node.removeNodeFromMathView();
      }

    });
  }

  clearPredicates() {
    this.unaryPredicates = new Set();
    this.increaseChangeCounter();
  }

  getUnaryPredicates() {
    return this.unaryPredicates;
  }

  increaseChangeCounter() {
    this.changeCounter += 1;
  }

  addUnaryPredicateToSet(name) {
    this.unaryPredicates.add(name);
    this.increaseChangeCounter();
  }

  addUnaryPredicate(name) {
    name = name.replace(/\s/g, "");

    if (!this.unaryPredicates.has(name)) {
      this.getReduxProps()["addUnaryPredicate"](name, this.getNodeName());
      this.addUnaryPredicateToSet(name);
    }
  }

  removeUnaryPredicate(name) {
    if (this.unaryPredicates.has(name)) {
      this.removeUnaryPredicateFromSet(name);
      this.getReduxProps()["removeUnaryPredicate"](name, this.getNodeName());
    }
  }

  removeNodeFromMathView() {
    for (let unaryPredicate of this.unaryPredicates) {
      this.getReduxProps()["removeUnaryPredicate"](unaryPredicate, this.getNodeName());
    }

    this.getReduxProps()["removeDomainNode"](this.getNodeName());
  }

  removeUnaryPredicateFromSet(name) {
    this.unaryPredicates.delete(name);
    this.increaseChangeCounter();
  }

  getNodeName() {
    return this.getOptions().name;
  }

  getAppendPort() {
    return this.appendPort;
  }

  renameNode(name) {
    this.getOptions().name = name;
  }

  removePort(port) {
    for (let link of _.values(port.getLinks())) {
      link.remove();
    } //clear the parent node reference


    if (this.ports[port.getName()]) {
      this.ports[port.getName()].setParent(null);
      delete this.ports[port.getName()];
    }
  }

  serialize() {
    return { ...super.serialize(),
      changeCounter: this.changeCounter,
      appendPort: this.appendPort,
      editable: this.editable
    };
  }

  deserialize(event) {
    super.deserialize(event);
    this.changeCounter = event.date.changeCounter;
    this.appendPort = event.data.appendPort;
    this.editable = event.data.editable;
  }

}